import { useEffect } from 'react';
import PropTypes from 'prop-types';

import { useLayoutContext } from './LayoutContext';

function LayoutHelmet(props) {
    const { setLayoutState, resetLayoutState } = useLayoutContext();
    const { layoutState } = props;
    useEffect(() => {
        setLayoutState(layoutState);
        return () => {
            resetLayoutState();
        };
    }, [layoutState, setLayoutState, resetLayoutState, layoutState?.title]);
    return null;
}

LayoutHelmet.propTypes = {
    layoutState: PropTypes.shape({
        title: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.func]),
        headerPlaceholder: PropTypes.func,
    }),
};

LayoutHelmet.defaultProps = {
    layoutState: {
        title: '',
        headerPlaceholder: () => null,
    },
};

LayoutHelmet.contextTypes = {
    setLayoutState: PropTypes.func,
    resetLayoutState: PropTypes.func,
};

export default LayoutHelmet;
